/** BFF sentinel: `WHERE category_id IS NULL`. Sent as string in query params. */
export const UNCATEGORIZED_CATEGORY_ID = '-1';

/** BFF sentinel: `WHERE segment_id IS NULL`. Sent as string in query params. */
export const UNCATEGORIZED_SEGMENT_ID = '-1';

export const UNCATEGORIZED_CATEGORY_LABEL = 'Uncategorized';
export const ALL_CATEGORIES_LABEL = 'All Categories';
export const ALL_SEGMENTS_LABEL = 'All Segments';
